import React from 'react'

import mutation from './mutation.graphql'

import DeleteEntityModal from 'components/shared/DeleteEntityModal'

export default function DeleteParentModal(props) {
  const { parent } = props

  return (
    <DeleteEntityModal
      entity={parent}
      modalId={`confirmDeleteParent${parent.id}`}
      fieldGroup='parents'
      modalTitle='Delete Parent?'
      successMessage='Parent Deleted'
      mutation={mutation}
      mutationName='deleteParent'
      {...props}
    />
  )
}
